import { forwardRef, useState } from "react";

/*eslint-disable */

declare const window: any;

interface TecnologiaVehiculosComponentProps {
  tecnologias: any;
}

const TecnologiaVehiculosComponent = forwardRef<HTMLDivElement, 
  TecnologiaVehiculosComponentProps
>  (({ tecnologias }, ref) => {
  const [currentIndex, setCurrentIndex] = useState(0); // Inicialmente se muestra la imagen en el centro

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : tecnologias?.tecnologia?.length - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex < tecnologias?.tecnologia?.length - 1 ? prevIndex + 1 : 0
    );
  };

  return (
    <div className="tecnologia-vehiculos-detail-component" ref={ref}>
      <div
        className="carrousel-tecnologia-vehiculos-detail-component"
        style={{
          transform: `translateX(-${currentIndex * 100}%)`,
        }}
      >
        {tecnologias?.tecnologia?.map((item: any, index: any) => (
          <div className={`item-tecnologia-vehiculos-detail-component`}>
            <img src={`https://manager.hyundaicolombia.co/${item?.media?.url}`} alt="" />
          </div>
        ))}
      </div>
      <div className="info-tecnologia-vehiculos-detail-component" style={tecnologias?.tecnologia?.length < 6 ? {justifyContent: "center"} : {} }>
        {tecnologias?.tecnologia?.map((item: any, index: number) => (
          <div
            className={`item-info-tecnologia-vehiculos-detail-component ${
              index === currentIndex ? "active" : ""
            }`}
            onClick={() => setCurrentIndex(index)}
          >
            <div className="title-info-tecnologia-vehiculos-detail-component">
              {item.title}
            </div>
            <div className="descripcion-info-tecnologia-vehiculos-detail-component">
              {item.description}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
)

export default TecnologiaVehiculosComponent;
